import { c as _c } from "react/compiler-runtime";
import { CircleSpinnerInline, colors, fontFamilies, fontSizes, IconClose as IconNavigationClose, IconSearch2 as IconGlobalSearch } from '@newfront-insurance/core-ui';
import { useContext, type JSX } from 'react';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { ACTIVE_GLOBAL_SEARCH_KEY } from '../../app-header/lib/consts';
import { SearchContext } from '../context';
interface Props {
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onReset: () => void;
  placeholder: string;
  innerRef: React.RefObject<HTMLInputElement>;
}
export function InputSearch(t0) {
  const $ = _c(24);
  const {
    innerRef,
    onChange,
    onReset,
    onKeyDown,
    placeholder
  } = t0;
  const {
    currentQuery,
    isSearching,
    results,
    error
  } = useContext(SearchContext);
  let t1;
  if ($[0] !== innerRef?.current || $[1] !== onReset) {
    t1 = () => {
      innerRef?.current?.focus();
      onReset();
    };
    $[0] = innerRef?.current;
    $[1] = onReset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOnReset = t1;
  const t2 = !!currentQuery && !isSearching && (!!results || !!error);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StyledIconSearch><IconGlobalSearch /></StyledIconSearch>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== currentQuery) {
    t4 = e => {
      if (!currentQuery && e.key === ACTIVE_GLOBAL_SEARCH_KEY) {
        e.preventDefault();
      }
    };
    $[4] = currentQuery;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentQuery || $[7] !== innerRef || $[8] !== onChange || $[9] !== onKeyDown || $[10] !== placeholder || $[11] !== t4) {
    t5 = <input name="global-search" ref={innerRef} placeholder={placeholder} onChange={onChange} value={currentQuery} autoComplete="off" autoFocus={true} onKeyDown={onKeyDown} onKeyPress={t4} />;
    $[6] = currentQuery;
    $[7] = innerRef;
    $[8] = onChange;
    $[9] = onKeyDown;
    $[10] = placeholder;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== currentQuery || $[14] !== isSearching) {
    t6 = currentQuery && isSearching && <StyledCircleSpinner><CircleSpinnerInline size={16} /></StyledCircleSpinner>;
    $[13] = currentQuery;
    $[14] = isSearching;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== currentQuery || $[17] !== handleOnReset) {
    t7 = currentQuery && <StyledButtonIconReset onClick={handleOnReset}><IconNavigationClose color={colors.steel[400]} /></StyledButtonIconReset>;
    $[16] = currentQuery;
    $[17] = handleOnReset;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t2 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <StyledInputSearch isResultActive={t2}>{t3}{t5}{t6}{t7}</StyledInputSearch>;
    $[19] = t2;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
const StyledInputSearch = styled.div<{
  isResultActive: boolean;
}>`
  --icon-size: 14px;
  --default-spacing: 12px;

  position: relative;
  z-index: 4;

  input {
    background: #fff;
    border-radius: 8px;
    ${({
  isResultActive
}) => isResultActive && css`
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `}
    border: none;

    box-sizing: border-box;
    display: block;
    font-family: ${fontFamilies.body};
    font-size: ${fontSizes.large.fontSize};
    height: 100%;
    min-height: 72px;
    padding: 1rem 2rem;
    padding-left: calc(1.5rem + var(--icon-size) + var(--default-spacing));
    text-decoration: none;
    text-overflow: ellipsis;
    width: 100%;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: rgba(84, 106, 131, 0.5);
    }
  }
`;
const StyledIconSearch = styled.div`
  left: 1.5rem;
  line-height: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.steel[400]};
`;
const StyledButtonIconReset = styled.div`
  cursor: pointer;
  line-height: 0;
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
`;
const StyledCircleSpinner = styled.div`
  line-height: 0;
  position: absolute;
  right: calc(25px + var(--icon-size) + var(--default-spacing));
  top: 50%;
  transform: translateY(-50%);
`;